import { useAppSelector } from '../stores/redux.store';
import type { AwsWafConfig } from '../types';
import { isValidAwsWafConfig } from './aws-captcha.helpers';

/**
 * Returns the resolved AWS WAF config from the `awsCaptcha` slice, or `null` when the config is
 * absent or either required field (`integrationUrl`, `apiKey`) is empty. The config is resolved
 * for the current hostname (and excluded on FedRAMP Moderate) once at the fetch boundary, so this
 * only needs to validate the flat shape.
 */
export const useAwsWafConfig = (): AwsWafConfig | null => {
  const awsWafConfig = useAppSelector(state => state.awsCaptcha.config);

  // Can be empty string for environments that don't have this config
  if (!isValidAwsWafConfig(awsWafConfig)) {
    return null;
  }

  return awsWafConfig;
};
